<template>
  <!-- :disabled="!isEditMode" -->
  <div
    v-if="train.closed && taktarea_index === 0 || !train.closed"
    class="taktarea-intersection-placeholder"
    v-intersect="onintersect"
    :style="`
      width: calc((${getProjectLength(project_id) + 2} * (var(--workpackage_width) + 8px) + var(--project_taktplan_ta_header_width) * 1px + var(--project_taktplan_spatial_header_width) * 1px) * var(--taktplan_zoom));
      ${backlog
        ? `height: calc((var(--workpackage_height) + 8px) * var(--taktplan_zoom) * ${(getWBWorkpackagesForTaktplan({hist: is_hist, wbline: taktarea}).max_y_index+1)/ 2});`
        : ''
      }`"
    >
    <v-hover
      >
      <template #default="{hover}">
        <transition
          name="grow-y"
          >
          <TaktArea
            v-if="dragging_ta || ((show_taktarea || taktarea_index === 0) && (train.closed && taktarea_index === 0 || !train.closed)) || $store.state.View.is_printing_mode"
            :id="`${backlog?'wbline':'taktarea'}${taktarea.id}`"
            :ref="`${backlog?'wbline':'taktarea'}${taktarea.id}`"
            :key="`${backlog?'wbline':'taktarea'}${taktarea.id}`"
            :project_length="getProjectLength(project_id)"
            :backlog="backlog"
            :height="backlog?`calc((var(--workpackage_height) + 8px) * var(--taktplan_zoom) * ${(getWBWorkpackagesForTaktplan({hist: is_hist, wbline: taktarea}).max_y_index+1)/ 2})`:false"
            header_width="var(--project_taktplan_ta_header_width) * 1px + var(--project_taktplan_spatial_header_width) * 1px"
            :style="is_last ? 'position: relative;' : ''"
            >
            <template #taktarea_header>
              <!-- Header name: Train open -->
              <template v-if="!train.closed">
                <!-- border-bottom: solid black 2px -->
                <HeaderRow
                  v-if="false"
                  style="height: 100%; border-style: solid;
                  border-width: 0px 0px 1px 0px; border-color: var(--header_border_color) !important"
                  :class="hover && ['TrainMilestonesAdd', 'TrainMilestonesEdit'].includes($route.name)?'border-white-hover cursor-pointer':!isEditMode?'cursor-pointer':''"
                  :z_index="6"

                  width="calc(var(--project_taktplan_spatial_header_width) * 1px * var(--taktplan_zoom))"
                  sticky_left="0px"
                  :text="getUObject({type: 'projects', id: project_id}).showMilestones ? '' : train.name"
                  :key="`trainname${train.id}`"

                  :color="train.closed?'color-1-5':''"
                  text_color="primary"
                  :readonly="true"
                  @click.native="
                    isEditMode?
                    handleHeaderRowClick(train, taktarea)
                    :
                    updateUDObject({
                      url: train_url,
                      update: {
                        closed: false
                      }
                    })"
                  />
                  <!-- :taktarea_count="train.closed?1:train[taktareas_string].length" -->
                <HeaderTrainOpen
                  v-if="taktarea_index === 0"
                  :style="`border-top: 1px solid ${$vuetify.theme.dark ? 'black' : 'white'} !important;`"
                  :taktarea_count="train.closed?1:taktarea_count"
                  :wbline_ids="backlog?train.wblines:false"
                  @click.native="
                    toggleWaggonTransition(),
                    updateUDObject({
                      url: train_url,
                      update: {
                        closed: !train.closed
                      }
                    })"
                  >
                  <!-- <imput v-if="!getUObject({type: 'projects', id: project_id}).showMilestones"
                    :value="train.name"
                    :disabled="hover && isEditMode && $route.name === 'ProjectTaktPlan'? false:true"
                    @keyup.enter="$refs.inputfield.blur()"
                    @blur="updateUObject({
                        url: [
                          {projects: project_id},
                          {trains: train.id},
                        ],
                        update: {
                          name: $event.target.value
                        }
                      })"
                  /> -->
                  <div v-if="!getUObject({type: 'projects', id: project_id}).showMilestones">{{train.name}}</div>
                </HeaderTrainOpen>
                <div v-else style="width: calc(var(--project_taktplan_spatial_header_width) * 1px * var(--taktplan_zoom))"/>
              </template>
              <!-- Header name: Train closed -->
              <!-- :border_color="getHeaderRowBorder('trains', train, new_milestone, 'black')" -->
              <!-- border_color="red" -->
              <!-- border_width="1px 1px 1px 1px" -->
              <HeaderRow
                v-if="train.closed"
                style="height: 100%; border-style: solid;border-width: 0px 0px 1px 0px; border-color: var(--header_border_color) !important"
                :class="hover && ['TrainMilestonesAdd', 'TrainMilestonesEdit'].includes($route.name)?'border-white-hover cursor-pointer':!isEditMode?'cursor-pointer':''"
                :z_index="6"
                width="calc(var(--project_taktplan_spatial_header_width) * 1px * var(--taktplan_zoom))"
                sticky_left="0px"
                :text="getUObject({type: 'projects', id: project_id}).showMilestones ? '' : train.name"
                :key="`trainname${train.id}`"
                :color="train.closed?'color-1-5':''"
                text_color="primary"
                :readonly="hover && isEditMode && $route.name === 'ProjectTaktPlan' && hasProjectPermission({'project_id': project_id, ppermission: 'Update Trains'})? false:true"
                @click.native="
                  isEditMode?
                  handleHeaderRowClick(train, taktarea)
                  :
                  updateUDObject({
                    url: train_url,
                    update: {
                      closed: false
                    }
                  })"
                  @changeValue="updateUObject({
                      url: train_url,
                      update: {
                        name: $event
                      }
                    })"
                >
                <template #middle-left>
                  <ActivatorDelete
                    class="self-centered cursor-not-allowed"
                    :key="`taktareadeleteactivator${taktarea.id}`"
                    v-if="hover && isEditMode && $route.name === 'ProjectTaktPlan' && hasProjectPermission({'project_id': project_id, ppermission: 'Delete Trains'})"
                    color="#EF5350"
                    @activatorDelete="
                      deleteUObject({
                          trainsbacklogs: true,
                          url: train_url
                        }).then(() => {
                          updateCalenderLookup(project_id)
                        })"
                    />
                  </template>
                <template #top-center>
                    <Activator
                      class="self-centered cursor-cell"
                      v-if="hover && isEditMode && $route.name === 'ProjectTaktPlan' && hasProjectPermission({'project_id': project_id, ppermission: 'Add Trains'})"
                      :addTrain="true"
                      @addTrain="
                      $router.push({
                        name: 'AddTrain',
                        params: {
                          project_id: project_id,
                          train_index: train_index,
                          train_id: train.id,
                          direction: 0,
                        }
                        })"
                      @addBacklog="createUObject({
                        url: [
                          {projects: project_id},
                          {wbgroups: ''},
                          {showWithEntitiesNormalized: ''}
                        ],
                          u_object: {
                            name: 'New Group',
                            description: 'description',
                            position: train_index + 1,
                          },
                          trainsbacklogs: true,
                        }).then(group_id => {
                          createUObject({
                            url: [
                              {projects: project_id},
                              {wbgroups: group_id},
                              {wblines: ''},
                              {showWithEntitiesNormalized: ''}
                            ],
                              u_object: {
                                name: 'New Line',
                                description: 'description',
                                position: 1
                              }
                            })
                          })"
                          @addEmptyTrain="createUObject({
                            url: [
                              {projects: project_id},
                              {trains: 'completetrain'},
                              {showWithEntitiesNormalized: ''}
                            ],
                            u_object: getEmptyTrainPayload($event, train_index + 1),
                            trainsbacklogs: true,
                          })"
                      />
                </template>
                <template #bottom-center>
                    <Activator
                      class="self-centered cursor-cell"
                      v-if="train.closed && hover && isEditMode && $route.name === 'ProjectTaktPlan' && hasProjectPermission({'project_id': project_id, ppermission: 'Add Trains'})"
                      :addTrain="true"
                      @addTrain="
                      $router.push({
                        name: 'AddTrain',
                        params: {
                          project_id: project_id,
                          train_index: train_index,
                          train_id: train.id,
                          direction: 1,
                        }
                        })"
                       @addBacklog="createUObject({
                        url: [
                          {projects: project_id},
                          {wbgroups: ''},
                          {showWithEntitiesNormalized: ''}
                        ],
                          u_object: {
                            name: 'New Group',
                            description: 'description',
                            position: train_index + 1 + 1,
                          },
                          trainsbacklogs: true,
                        }).then(group_id => {
                          createUObject({
                            url: [
                              {projects: project_id},
                              {wbgroups: group_id},
                              {wblines: ''},
                              {showWithEntitiesNormalized: ''}
                            ],
                              u_object: {
                                name: 'New Line',
                                description: 'description',
                                position: 1
                              }
                            })
                          })"
                          @addEmptyTrain="createUObject({
                            url: [
                              {projects: project_id},
                              {trains: 'completetrain'},
                              {showWithEntitiesNormalized: ''}
                            ],
                            u_object: getEmptyTrainPayload($event, train_index + 1 + 1),
                            trainsbacklogs: true,
                          })"
                      />
                </template>
              </HeaderRow>
              <!-- Header Info: Train Open -->
              <!-- border-bottom: solid black 2px -->
              <!-- :border_color="getHeaderRowBorder('taktareas', taktarea, new_milestone, '#424242')" -->
              <!-- NOTE: 'hover &&' used to be in :readonly attribute -->
              <HeaderRow
                v-if="!train.closed"
                style="height: 100%;"
                z_index="6"
                sticky_left="calc(var(--project_taktplan_spatial_header_width) * 1px * var(--taktplan_zoom))"
                width="calc(var(--project_taktplan_ta_header_width) * 1px * var(--taktplan_zoom))"
                :key="`taktareaname${taktarea.id}`"
                :class="hover && ['TrainMilestonesAdd', 'TrainMilestonesEdit'].includes($route.name)?'cursor-pointer color-1':'color-1'"

                :inner_border="`solid 1px rgba(${$vuetify.theme.isDark ? '255,255,255' : '0,0,0'},0.8)`"
                :text="taktarea.name"
                :description="$store.state.View.is_taktplan_taktarea_description ? taktarea.description : ''"
                :readonly="hover && isEditMode && $route.name === 'ProjectTaktPlan' && hasProjectPermission({'project_id': project_id, ppermission: 'Update Taktareas'})? false:true"
                @click.native="handleHeaderRowClick(train, taktarea)"
                @changeValue="updateUObject({
                    url: taktarea_url,
                    update: {
                      name: $event
                    }
                  })"
                >
                <template #middle-left>
                  <ActivatorDelete
                    class="self-centered cursor-not-allowed"
                    :key="`taktareadeleteactivator${taktarea.id}`"
                    v-if="hover && isEditMode && $route.name === 'ProjectTaktPlan' && hasProjectPermission({'project_id': project_id, ppermission: 'Delete Taktareas'})"
                    color="#EF5350"
                    @activatorDelete="
                      backlog?
                      deleteUObject({
                          url: train.wblines.length === 1?train_url:taktarea_url,
                          trainsbacklogs: train.wblines.length === 1?true:false,
                        })
                      :
                      deleteUObject({
                          url: train.taktareas.length === 1?train_url:taktarea_url,
                          trainsbacklogs: train.taktareas.length === 1?true:false
                        }).then(() => {
                          train.taktareas.length === 1?
                        '':changeTaktAreaStartBulk()
                        }).then(() => {
                          updateCalenderLookup(project_id)
                        })"
                    />
                  </template>
                <template #middle-right>
                  <Activator
                    icon="area-shaded"
                    class="self-centered cursor-pointer"
                    :key="`taktareaopenactivator${taktarea.id}`"
                    v-if="!backlog && hover  && $route.name === 'ProjectTaktPlan'"
                    @click.native="$router.push({
                        name: 'TaktPlanTaktareaDetails',
                        params: {
                          project_id: project_id,
                          train_id: train.id,
                          taktarea_id: taktarea.id
                        }
                      })"
                    />
                  </template>
                <template #top-center>
                  <Activator
                    class="self-centered cursor-cell"
                    v-if="backlog && hover && isEditMode && $route.name === 'ProjectTaktPlan' && hasProjectPermission({'project_id': project_id, ppermission: 'Add WBLines'})"
                    @click.native="
                    createUObject({
                      url: [
                        {projects: project_id},
                        {wbgroups: train.id},
                        {wblines: ''},
                        {showWithEntitiesNormalized: ''}
                      ],
                        u_object: {
                          name: 'New Line',
                          description: 'description',
                          position: taktarea_index + 1
                        }
                      })"
                    />
                  <ActivatorInsert
                    class="self-centered cursor-cell"
                    :key="`taktarea_add_top_activator${taktarea.id}`"
                    v-else-if="hover && isEditMode && $route.name === 'ProjectTaktPlan' && hasProjectPermission({'project_id': project_id, ppermission: 'Add Taktareas'})"
                    @insert="parseInt($event) > 0?createUObject({
                        url: [
                          {projects: project_id},
                          {trains: train.id},
                          {taktareas: 'copytaktareabulk'},
                          {showWithEntitiesNormalized: ''}
                        ],
                        u_object: {
                          taktarea_copy: taktarea.id,
                          taktareas: getTaktareasForCreateBulk(
                            $event,
                            taktarea.taktarea_start,
                            taktarea_index + 1,
                            0
                          )
                        }
                      }).then(() => {
                        updateCalenderLookup(project_id)
                      })
                    :''
                    "
                    />
                </template>
                <template #bottom-center>
                  <Activator
                    class="self-centered cursor-cell"
                    v-if="backlog && hover && isEditMode && $route.name === 'ProjectTaktPlan' && hasProjectPermission({'project_id': project_id, ppermission: 'Add WBLines'})"
                    @click.native="
                    createUObject({
                      url: [
                        {projects: project_id},
                        {wbgroups: train.id},
                        {wblines: ''},
                        {showWithEntitiesNormalized: ''}
                      ],
                        u_object: {
                          name: 'New Line',
                          description: 'description',
                          position: taktarea_index + 2
                        }
                      })"
                    />
                  <ActivatorInsert
                    class="self-centered cursor-cell"
                    :key="`taktarea_add_bottom_activator${taktarea.id}`"
                    v-else-if="hover && isEditMode && $route.name === 'ProjectTaktPlan' && hasProjectPermission({'project_id': project_id, ppermission: 'Add Taktareas'})"
                    @insert="parseInt($event) > 0?createUObject({
                        url: [
                          {projects: project_id},
                          {trains: train.id},
                          {taktareas: 'copytaktareabulk'},
                          {showWithEntitiesNormalized: ''}
                        ],
                        u_object: {
                          taktarea_copy: taktarea.id,
                          taktareas: getTaktareasForCreateBulk(
                            $event,
                            taktarea.taktarea_start,
                            taktarea_index + 1,
                            0
                          )
                        }
                      }).then(() => {
                        updateCalenderLookup(project_id)
                      })
                    :''
                    "
                    />
                </template>
              </HeaderRow>
              <!-- Header Info: Train Closed -->
              <!-- border_color="black"
              border_width="1px 1px 1px 0px" -->
              <HeaderPlaceholder
                v-else
                class="cursor-pointer"
                width="calc(var(--project_taktplan_ta_header_width) * 1px * var(--taktplan_zoom))"
                height="calc((var(--workpackage_height) + 8px) * var(--taktplan_zoom))"
                z_index="4"
                sticky_left="calc(var(--project_taktplan_spatial_header_width) * 1px * var(--taktplan_zoom))"

                style="overflow: hidden; height: 100%"
                @click.native="updateUDObject({
                    url: train_url,
                    update: {
                      closed: false
                    }
                  })"
                >
                <TrainHead :backlog="backlog" :zoom="0.3" :color="$vuetify.theme.dark?'rgba(255,255,255,0.9)':'color-0'"/>
                <!-- <div style="margin: 0px 2px 0px 2px">{{train[taktareas_string].length}}</div> -->
                <div style="margin: 0px 2px 0px 2px">{{ taktarea_count }}</div>
                <TrainTail :backlog="backlog" :zoom="0.3" :color="$vuetify.theme.dark?'rgba(255,255,255,0.9)':'color-0'"/>
              </HeaderPlaceholder>

              <!-- <v-text-field class="taktarea-description" label="Description" :value="taktarea.description"></v-text-field> -->


            </template>
            <template #taktarea>
              <!-- Takt time Highlighter -->
              <TaktTimeHighLighter
                v-if="current_takt_index !== false &&
                      $store.state.View.is_taktplan_takttime_highlight"
                :index="isSpatialView ? Math.abs(current_takt_index) : Math.abs(current_takt_index) + 1"
                header_width="var(--project_taktplan_ta_header_width) * 1px + var(--project_taktplan_spatial_header_width) * 1px"
                z_index="1"
              />
              <TaktTimeHighLighter
                v-if="current_takt_index !== false &&
                      current_takt_index >= 0 &&
                      $store.state.View.is_taktplan_takttime_highlight"
                :index="isSpatialView ? current_takt_index + 1 : current_takt_index + 2"
                header_width="var(--project_taktplan_ta_header_width) * 1px + var(--project_taktplan_spatial_header_width) * 1px"
                z_index="1"
              />
              <!-- MILESTONE HIGHLIGHT --> 
              <template v-if="$store.state.View.is_taktplan_milestone_highlight && getUObject({ type: 'projects', id: project_id }).showMilestones">
                <TaktTimeHighLighter
                  v-for="milestone, i in getMileStones(project_id)"
                  :key="`takt-plan-milestone-highlight-${i}`"
                  :index="milestone.takt_index.index + 1"
                  header_width="var(--project_taktplan_ta_header_width) * 1px + var(--project_taktplan_spatial_header_width) * 1px - 1px"
                  border_style="dashed"
                />
                <TaktTimeHighLighter
                  v-for="pmilestone, i in getPMileStones(project_id)"
                  :key="`takt-plan-pmilestone-highlight-${i}`"
                  :index="pmilestone.takt_index.index + 1"
                  header_width="var(--project_taktplan_ta_header_width) * 1px + var(--project_taktplan_spatial_header_width) * 1px - 1px"
                  border_style="dashed"
                />
              </template>
              <!-- /MILESTONE HIGHLIGHT -->

              <!-- :readonly="hover.hover && isEditMode? false:true" -->

              <!-- :color="isInsertingTrain &&
              $route.params.train_index + $route.params.direction === train_index?'blue':false" -->

              <!-- :border_width="!['TrainMilestonesAdd', 'TrainMilestonesDetails', 'TrainMilestonesEdit'].includes($route.name)?'0px 0px 1px 0px':''" -->
              <!--
              :text="train.closed? train.name + 'ssss':taktarea.name" -->

              <!-- taktarea header -->
              <!-- :border_width="!['TrainMilestonesAdd', 'TrainMilestonesDetails', 'TrainMilestonesEdit'].includes($route.name)?'0px 0px 1px 0px':''" -->
              <template v-if="!backlog">
              <!-- Placeholder until trainstart -->
              <Placeholder
                v-if="!$store.state.View.takt_time_filter.active || ( train.train_start > $store.state.View.takt_time_filter.start && train.train_start < $store.state.View.takt_time_filter.end)"
                @click.native="routeToTaktplan()"
                :id="`placeholder_trainstart_${train.id}`"
                :ref="`placeholder_trainstart_${train.id}`"
                :key="`placeholder_trainstart_${train.id}`"
                :count="$store.state.View.takt_time_filter.active ? getTrainPlaceholderFilteredCount(train) : train.train_start"
                :class="getMoveTrainStartVariables.move_train_start? '':'transition-all'"
                >
                <template #bottom-right>
                  <Activator
                    class="self-centered cursor-col-resize center-activator"
                    :key="`taktareaactivator${taktarea.id}`"
                    v-if="train.closed && taktarea_index === 0 && hover && isEditMode && $route.name === 'ProjectTaktPlan' && hasProjectPermission({'project_id': project_id, ppermission: 'Update Trains'})"
                    @mouseenter.native="$emit('toggleDraggable', true)"
                    @mouseleave.native="getMoveTrainStartVariables.move_train_start? '':$emit('toggleDraggable', false)"
                    @mousedown.native="moveTrainStartMouseDown({
                      train_id: train.id,
                      taktarea_id: taktarea.id,
                      taktarea_index: taktarea_index,
                      train_start: train.train_start,
                      evt: $event,
                      })"
                  />
                </template>
              </Placeholder>
              <!-- style="margin-top: 5px" -->
              <!-- <template v-if="!$store.state.View.takt_time_filter.active || (train.train_start + taktarea.taktarea_start > parseInt($store.state.View.takt_time_filter.start))"> -->
                <TrainHead
                  v-if="taktarea_index === 0"
                  :is_taktarea="!train.closed"
                  class="cursor-pointer"
                  :key="`trainhead${taktarea.id}`"
                  :edit_mode="isEditMode && hasProjectPermission({'project_id': project_id, ppermission: 'Update Trains'})"
                  @click.native="
                    toggleWaggonTransition(),
                    updateUDObject({
                      url: train_url,
                      update: {
                        closed: !train.closed
                      }
                    })"
                />
                <Placeholder
                  @click.native="routeToTaktplan()"
                  v-else :count="1"
                  :key="`placeholdertrainhead${taktarea.id}`"
                  :taktarea_drag="taktarea.taktarea_start === 0 && !taktarea_activator_hover && isEditMode"
                  :hover="hover"
                />
              <!-- </template> -->
              <Placeholder
                v-if="!$store.state.View.takt_time_filter.active || (train.train_start + taktarea.taktarea_start > parseInt($store.state.View.takt_time_filter.start) && train.train_start + taktarea.taktarea_start < parseInt($store.state.View.takt_time_filter.end))"
                @click.native="routeToTaktplan()"
                :id="`placeholder_taktareastart_${taktarea.id}`"
                :ref="`placeholder_taktareastart_${taktarea.id}`"
                :key="`placeholder_taktareastart_${taktarea.id}`"
                :count="$store.state.View.takt_time_filter.active ? getTaktareaPlaceholderFilteredCount(train, taktarea) : taktarea.taktarea_start"
                :class="getMoveTaktareaStartVariables.move_taktarea_start? '':'transition-all'"
                :taktarea_drag="!taktarea_activator_hover && taktarea.taktarea_start !== 0 && isEditMode"
                :hover="hover && hasProjectPermission({'project_id': project_id, ppermission: 'Update Taktareas'})"
                >
                <template #bottom-right>
                  <Activator
                    class="self-centered cursor-col-resize center-activator"
                    :key="`taktareaactivator${taktarea.id}`"
                    v-if="!train.closed &&
                          (hover || (snackbar.show &&
                          snackbar.hover &&
                          snackbar.action === 'updatetaktareastart' &&
                          snackbar.affected_targets.includes(taktarea.id))) &&
                          isEditMode &&
                          $route.name === 'ProjectTaktPlan' &&
                          hasProjectPermission({'project_id': project_id, ppermission: 'Update Taktareas'})
                        "
                    @mouseenter.native="$emit('toggleDraggable', true)"
                    @mouseleave.native="getMoveTaktareaStartVariables.move_taktarea_start?'':$emit('toggleDraggable', false)"
                    @mousedown.native="moveTaktareaStartMouseDown({
                      train_id: train.id,
                      taktarea_id: taktarea.id,
                      taktarea_start: taktarea.taktarea_start,
                      evt: $event,
                      })"
                  />
                </template>
              </Placeholder>
              <draggable
                class="display-flex"
                :key="`taktarewaggons${taktarea.id}`"
                animation="300"
                forceFallback="true"
                fallbackOnBody="true"
                :disabled="!hover ||
                           !isEditMode ||
                           $route.name !=='ProjectTaktPlan' ||
                           !hasProjectPermission({'project_id': project_id, ppermission: 'Update Waggons'})?
                           true:false"
                :value="taktarea.twaggons"
                @update="requestSnackbarUpdatePosition({
                    url: [
                      {projects: project_id},
                      {trains: train.id},
                      {taktareas: taktarea.id},
                      {twaggons: taktarea.twaggons[$event.oldIndex]},
                    ],
                    update: {
                      position: $event.newIndex - $event.oldIndex,
                      position_twaggons: taktarea.twaggons
                    },
                    selector: 'target',
                    limit_selector: true
                  }).then((payload) => {
                    updateUObjectPosition(payload)
                })"
                @start="dragging_waggon_id = taktarea.twaggons[$event.oldIndex]"
                @end="dragging_waggon_id = -1"
                >
                <!-- style="margin-top: 3px" -->
                <TPWaggon
                  v-for="(waggon, waggon_index) in twaggons"
                  :key="`waggonhoveractivtor${waggon.id}`"
                  :waggon_transition="waggon_transition"
                  :project_id="project_id"
                  :train="train"
                  :taktarea="taktarea"
                  :location="location"
                  :waggon="waggon"
                  :waggon_index="waggon_index"
                  :new_milestone="new_milestone"
                  :milestone_selection="milestone_selection"
                  :takt_index="train.train_start + taktarea.taktarea_start + waggon_index"
                  :snackbar="snackbar"
                  :dragging="dragging_ta || dragging_waggon_id === waggon.id"
                />
              </draggable>
              <!-- margin-top: 3px -->
              <template v-if="train.closed">
                <div style="display: flex; ">
                  <TWaggon
                    v-for="waggon in (train_length - taktarea_length - train.train_start)"
                    :key="`waggonPlaceholder${taktarea.id}${waggon}`"
                    :dummy="true"
                  />
                </div>
              </template>
              <template v-else-if="taktarea_index === train[taktareas_string].length-1">
                <Placeholder @click.native="routeToTaktplan()"  :count="train_length - taktarea_length - train.train_start"/>
              </template>
              <!-- style="margin-top: 5px" -->
              <TrainTail

                v-if="taktarea_index === train[taktareas_string].length-1 ||
                  train.closed"
                :is_taktarea="!train.closed"
                :edit_mode="isEditMode"
                />
              </template>
              <!-- backlogs -->
              <template v-else>
                <!-- <TrainHead
                  v-if="taktarea_index === 0 && false"
                  :is_taktarea="!train.closed"
                  class="cursor-pointer"
                  :key="`trainhead${taktarea.id}`"
                  :edit_mode="isEditMode"
                  :backlog="true"
                  @click.native="
                    toggleWaggonTransition(),
                    updateUDObject({
                      url: train_url,
                      update: {
                        closed: !train.closed
                      }
                    })"
                /> -->
                <!-- :taktarea_drag="taktarea.taktarea_start === 0 && !taktarea_activator_hover && isEditMode" -->
                <Placeholder
                  @click.native="routeToTaktplan()"
                  :count="1"
                  :key="`placeholdertrainhead${taktarea.id}`"
                  :taktarea_drag="isEditMode"
                  :hover="hover"
                  :wbgroup_drag_handle="train.closed"
                />
                <div
                :style="`
                  position: relative;
                  width: calc((${getProjectLength(project_id) + 1} * (var(--workpackage_width) + 8px)) * var(--taktplan_zoom));
                  `"
                  @dblclick="initiateNewWBWorkpackage({
                    evt: $event,
                    wb_position: 1,
                    })"
                  >
                  <BacklogWorkpackage
                    v-if="new_wp_position && $route.params.wbline_id === taktarea.id"
                    :wbworkpackage="{color: 'blue', position: new_wp_position, length: 1, height: 1, y_index: 0, add_wp: true, status: 'none', stop_status: 'none'}"
                    :isEditMode="isEditMode"
                  />
                  <BacklogWorkpackage
                    v-for="wbworkpackage in getWBWorkpackagesForTaktplan({hist: is_hist, wbline: taktarea}).wbworkpackages"
                    :key="`tpwbworkpackage${wbworkpackage.id}`"
                    :wbworkpackage="wbworkpackage"
                    :wbline_id="taktarea.id"
                    :project_length="getProjectLength(project_id)"
                    :isEditMode="isEditMode"
                    :color="workpackageColor(wbworkpackage)"
                    @clickWorkpackage="openWPInfo(train, taktarea, wbworkpackage)"
                    @dblclickWorkpackage="initiateNewWBWorkpackage({
                      evt: $event,
                      wb_position: wbworkpackage.position,
                      })"
                    @changeLength="updateUObject({
                        url: [
                          {projects: project_id},
                          {wbgroups: train.id},
                          {wblines: taktarea.id},
                          {wbworkpackages: wbworkpackage.id}
                        ],
                        update: {
                          length: parseInt(wbworkpackage.length) + parseInt($event) < 1?1:parseInt(wbworkpackage.length) + parseInt($event)
                        }
                      })"
                    @changePosition="updateUObject({
                        url: [
                          {projects: project_id},
                          {wbgroups: train.id},
                          {wblines: taktarea.id},
                          {wbworkpackages: wbworkpackage.id}
                        ],
                        update: {
                          position: parseInt(wbworkpackage.position) + parseInt($event) < 1?1:parseInt(wbworkpackage.position) + parseInt($event)
                        }
                      })"
                  />
                  <TText v-if="isEditMode && hover && taktarea.wbworkpackages.length === 0" text="doubleclick to add workpackage" style="user-select: none; cursor: default"/>
                </div>
              </template>
              <div
                v-if="is_last && $store.state.View.is_taktplan_train_seperator"
                class="primary tp-taktarea-seperator-container"
              >
                <div
                  class="color-1 primary tp-taktarea-seperator-sticky-block"
                  :style="`height: ${seperator_height}px; bottom: -${seperator_height / 2}px`"
                />
                <div
                  class="primary tp-taktarea-seperator"
                  :style="`height: ${seperator_height}px;`"
                />
              </div>
            </template>
          </TaktArea>
        </transition>
      </template>
    </v-hover>
</div>
</template>
<script>
  import { mapGetters, mapActions, mapState } from 'vuex';
  import { MilestonesMixin } from '@/mixins/Milestones.mixin.js';
  import { ProjectMixin } from '@/mixins/Project.mixin.js';
  import draggable from "vuedraggable";

  import TaktArea from '@/components/ProjectTaktPlan/TaktArea.component.vue';
  import TPWaggon from '@/views/Project/ProjectTaktPlan/TPWaggon.wrapper.vue';
  import HeaderRow from '@/components/ProjectTaktPlan/HeaderRow.component.vue';
  import HeaderPlaceholder from '@/components/ProjectTaktPlan/HeaderPlaceholder.component.vue';
  import TrainHead from '@/components/ProjectTaktPlan/TrainHead.component.vue'
  import Placeholder from '@/components/ProjectTaktPlan/Placeholder.component.vue'
  import TrainTail from '@/components/ProjectTaktPlan/TrainTail.component.vue'
  import TWaggon from '@/components/ProjectTaktPlan/Waggon.component.vue';
  import Activator from '@/components/ProjectTaktPlan/Activator.component.vue'
  import ActivatorInsert from '@/components/ProjectTaktPlan/ActivatorInsert.component.vue'
  import ActivatorDelete from '@/components/ProjectTaktPlan/ActivatorDelete.component.vue'
  import TaktTimeHighLighter from '@/components/ProjectTaktPlan/TaktTimeHighLighter.component.vue'
  import HeaderTrainOpen from '@/components/ProjectTaktPlan/HeaderTrainOpen.component.vue'

  import TText from '@/components/Taktify/TText.component.vue';

  import BacklogWorkpackage from '@/components/TaktPlanBacklogs/BacklogWorkpackage.component.vue'

  export default {
    props: [
      'project_id',
      'train',
      'train_index',
      'taktarea',
      'taktarea_index',
      'draggable_disabled',
      'new_milestone',
      'location',
      'milestone_selection',
      'snackbar',
      'dragging_ta',
      'backlog',
      'is_last',
      'taktarea_count',
      'current_takt_index',
    ],
    components: {
      draggable,
      TaktArea,
      TPWaggon,
      HeaderRow,
      HeaderPlaceholder,
      TrainHead,
      Placeholder,
      TrainTail,
      TWaggon,
      Activator,
      ActivatorInsert,
      ActivatorDelete,
      TaktTimeHighLighter,
      HeaderTrainOpen,
      TText,
      BacklogWorkpackage,
    },
    mixins: [
      MilestonesMixin,
      ProjectMixin,
    ],
    data: () => ({
      waggon_transition: true,
      taktarea_activator_hover: false,
      show_taktarea: false,
      dragging_waggon_id: -1,
      seperator_height: 2,
    }),
    // created() {
    //   console.log('taktarea', this.taktarea);
    // },
    computed: {
      is_hist(){
        if (this.location) {
          return this.location.includes('HistProject');
        }
        return false;
      },
      taktareas_string(){
        if (this.is_hist) {
          if (this.backlog) {
            return 'histwblines';
          } else {
            return 'histtaktareas';
          }
        } else {
          if (this.backlog) {
            return 'wblines';
          } else {
            return 'taktareas';
          }
        }
      },
      twaggons(){
        if (this.is_hist) {
          return this.getUObjects({type: 'histtwaggons', ids: this.taktarea.histtwaggons});
        } else {
          return this.getUObjects({type: 'twaggons', ids: this.taktarea.twaggons});
        }
      },
      train_length(){
        if (this.is_hist) {
          return this.getHistTrainLength(this.train.id);
        } else {
          return this.getTrainLength(this.train.id);
        }
      },
      taktarea_length(){
        if (this.is_hist) {
          return this.getHistTaktareaLength(this.taktarea.id);
        } else {
          return this.getTaktareaLength(this.taktarea.id);
        }
      },
      ...mapGetters('Ultra', [
        'getUObjects',
        'getUObject'
      ]),
      ...mapGetters('ProjectStatistics', [
        'getStatisticSettings',
      ]),
      // ...mapGetters('ProjectCalendar', [
      //   'getCurrentTaktIndex',
      // ]),
      ...mapGetters('ProjectMilestone', [
        'getNewMilestone',
        'getMileStoneLinkType',
      ]),
      ...mapGetters('Project', [
        'getProjectLength',
        'isEditMode',
        'isInsertingTrain',
        'hasProjectPermission',
      ]),
      ...mapGetters('Train', [
        'getMoveTrainStartVariables',
        'getTrainLength',
        'getHistTrainLength',
      ]),
      ...mapGetters('TaktArea', [
        'getTaktareaLength',
        'getHistTaktareaLength',
        'getMoveTaktareaStartVariables',
      ]),
      ...mapGetters('View', [
          'isSpatialView',
          'isShowOwnWps',
      ]),
      ...mapGetters('ProjectBacklog', [
        'getWBWorkpackagesForTaktplan'
      ]),
      ...mapState('ProjectBacklog', [
          'new_wp_position'
      ]),
      train_url() {
        if (this.backlog) {
          return [
            {projects: this.project_id},
            {wbgroups: this.train.id},
          ]
        } else if (this.is_hist) {
          return [
            {projects: this.project_id},
            {histtrains: this.train.id},
          ]
        } else {
          return [
            {projects: this.project_id},
            {trains: this.train.id},
          ]
        }
      },
      taktarea_url() {
        if (this.backlog) {
          return [
            {projects: this.project_id},
            {wbgroups: this.train.id},
            {wblines: this.taktarea.id},
          ]
        } else {
          return [
            {projects: this.project_id},
            {trains: this.train.id},
            {taktareas: this.taktarea.id},
          ]
        }
      },
    },
    methods: {
      getTrainPlaceholderFilteredCount(train) {
        const start = train.train_start - 1;
        const filter_start = parseInt(this.$store.state.View.takt_time_filter.start);
        const count = start - filter_start;
        if (count < 0) {
          return train.taktarea_start;
        }
        return count
      },
      getTaktareaPlaceholderFilteredCount(train, taktarea) {
        const start = train.train_start + taktarea.taktarea_start - 1;
        const filter_start = parseInt(this.$store.state.View.takt_time_filter.start);
        const count = start - filter_start;
        if (count < 0) {
          return taktarea.taktarea_start;
        }
        return count
      },
      getEmptyTrainPayload(count, position) {
      let train = {
        name: 'New Train',
        description: '',
        train_start: 0,
        workable_backlog: false,
        position: position,
        taktareas: [{
          name: 'A',
          description: '',
          taktarea_start: 0,
          square_meter: 0,
          waggons: [],
        }]
      };
      for (let i = 0; i < count; i++) {
        train.taktareas[0].waggons.push({status: 'open', work_packages: []});
      }
      return train;
    },
      workpackageColor(workpackage) {
        //flexbar filter
        if (this.getStatisticSettings.filter) {
          if (
            this.wpIsGrey('colors', workpackage.color) ||
            this.wpIsGrey('icons', workpackage.icon) ||
            this.wpIsGrey('status', workpackage.status, workpackage.stop_status) ||
            // this.wpIsGrey('status', workpackage.stop_status) ||
            // this.wpIsGrey('trains', this.train.id) ||
            //stopstatus
            (this.getStatisticSettings.status.length === 1 && this.getStatisticSettings.status.includes('stop') && workpackage.stop_status !== 'stop') ||
            (this.getStatisticSettings.status.length !== 0 && !this.getStatisticSettings.status.includes('stop') && workpackage.stop_status === 'stop')
          ) {
            return 'grey darken-2';
          }
        }
        //show own wps
        // hide backlog packages always if it is 'isShowOwnWps' because currently they are not assignable to craftsmen
        if (
          this.isShowOwnWps
          // && this.getOwnTWorkPackages(this.project_id).length !== 0
          // && !this.getOwnTWorkPackages(this.project_id).includes(workpackage.id)
        ) {
          return 'grey darken-2';
        }
        // take workpackage color
        return false;
      },
      wpIsGrey(settings_key, value, stop_status) {
        if (
          this.getStatisticSettings[settings_key].length !== 0 &&
          !this.getStatisticSettings[settings_key].includes(value)
          //prevent stop status
          && !(this.getStatisticSettings.status.includes('stop') && stop_status === 'stop')
        ) {
          return true;
        } else {
          // if (settings_key === 'status') {

          // }
          return false;
        }
      },
      initiateNewWBWorkpackage(payload) {
        if (this.isEditMode) {
          let position = Math.floor(payload.evt.offsetX / ((parseInt(getComputedStyle(document.body).getPropertyValue('--workpackage_width')) + 8) * this.$store.state.View.taktplan_zoom)) + payload.wb_position;
          this.setNewWPPosition(position);
          this.$router.push({name: 'TaktPlanAddWBWorkPackage', params: {
            wbgroup_id: this.train.id,
            wbline_id: this.taktarea.id
          }})
        }
      },
      openWPInfo(train,taktarea,wbworkpackage){
        if (this.is_hist) {
          this.$router.push({
            name: 'HistProjectTaktPlanBacklogWorkPackageInfo',
            params: {
              wbgroup_id: train.id,
              wbline_id: taktarea.id,
              wbworkpackage_id: wbworkpackage.id,
              tworkpackage_id: -1
            }
          });
        } else {
          this.$router.push({
            name: 'TaktPlanBacklogWorkPackageInfo',
            params: {
              wbgroup_id: train.id,
              wbline_id: taktarea.id,
              wbworkpackage_id: wbworkpackage.id
            }
          });
        }
      },
      ...mapActions('Ultra', [
        'createUObject',
        'updateUObject',
        'deleteUObject',
        'updateUObjectPosition',
      ]),
      ...mapActions('UltraDev', [
        'updateUDObject',
      ]),
      ...mapActions('View', [
        'setValue',
      ]),
      ...mapActions('ProjectMilestone', [
        'editMilestoneSelection',
        'editNewMilestoneSelection',
      ]),
      ...mapActions('TaktArea', [
        'changeTaktAreaStartBulk',
        'setMoveTaktareaStartVariables',
      ]),
      ...mapActions('Train', [
        'setMoveTrainStartVariables',
      ]),
      ...mapActions('SnackBar', [
        'requestSnackbarUpdatePosition',
      ]),
      ...mapActions('ProjectCalendar', [
        'updateCalenderLookup',
      ]),
      ...mapActions('ProjectBacklog', [
        'setNewWPPosition',
      ]),
      toggleWaggonTransition() {
        this.waggon_transition = false;
        let self = this;
        setTimeout(function () {
          self.waggon_transition = true;
        }, 1000);
      },
      getHeaderRowBorder(prop, value, new_milestone, color) {
        if (this.milestone_selection[prop].findIndex(entry => entry.id === value.id) !== -1 && ['TrainMilestonesDetails', 'TrainMilestonesEdit']
            .includes(this.$route.name)) {
          return 'var(--v-primary-base)';
        } else if (new_milestone.milestone[prop].findIndex(entry => entry.id === value.id) !== -1 && this.$route.name === 'TrainMilestonesAdd') {
          return 'var(--v-primary-base)';
        } else {
          return color;
        }
        // if (!['TrainMilestonesAdd', 'TrainMilestonesDetails', 'TrainMilestonesEdit']
        //     .includes(this.$route.name)) {
        //       return color;
        // } else if (['TrainMilestonesDetails', 'TrainMilestonesEdit']
        //     .includes(this.$route.name) && this.milestone_selection[prop].findIndex(entry => entry.id === value.id) !== -1) {
        //       return 'var(--v-primary-base)';
        // } else if (this.$route.name === 'TrainMilestonesAdd' && new_milestone.milestone[prop].findIndex(entry => entry.id === value.id) !== -1){
        //       return 'var(--v-primary-base)';
        // } else {
        //   return '';
        // }
      },
      handleHeaderRowClick(train, taktarea) {
        if (this.$route.name === 'TrainMilestonesAdd' && this.getNewMilestone(this.project_id).milestone.linkType === 'selection') {
          this.editNewMilestoneSelection({
              project_id: this.project_id,
              prop: train.closed?'trains':'taktareas',
              value: train.closed?train:taktarea,
            });
        } else if (this.$route.name === 'TrainMilestonesEdit' &&
          this.getMileStoneLinkType({
            project_id: this.project_id,
            milestone_id: this.$route.params.milestone_id
          }) === 'selection') {
            this.editMilestoneSelection({
              project_id: this.project_id,
              milestone_id: this.$route.params.milestone_id,
              prop: train.closed?'trains':'taktareas',
              value: train.closed?train:taktarea,
            });
          }
      },
      getTaktareasForCreateBulk(count, start, position, direction) {
        let taktareas = [];
        for (let i = 0; i < count; i++) {
          taktareas.push({
            taktarea_start: start + direction + i,
            position: position + direction + i,
          });
        }
        return taktareas;
      },
      moveTaktareaStartMouseDown(payload) {
        this.setValue({key: 'taktarea_dragging', value: true});
        
        this.$refs[`taktarea${payload.taktarea_id}`].$el.style.width =
          `${this.$refs[`taktarea${payload.taktarea_id}`].$el.clientWidth + window.innerWidth}px`;
        this.setMoveTaktareaStartVariables({
          initial_x: payload.evt.pageX,
          train_id: payload.train_id,
          taktarea_id: payload.taktarea_id,
          initial_width: this.$refs[`placeholder_taktareastart_${payload.taktarea_id}`].$el.clientWidth,
          move_taktarea_start: true,
        });
      },
      moveTrainStartMouseDown(payload) {
        this.$refs[`taktarea${payload.taktarea_id}`].$el.style.width =
          `${this.$refs[`taktarea${payload.taktarea_id}`].$el.clientWidth + window.innerWidth}px`;
        this.setMoveTrainStartVariables({
          initial_x: payload.evt.pageX,
          train_id: payload.train_id,
          taktarea_id: payload.taktarea_id,
          initial_width: this.$refs[`placeholder_trainstart_${payload.train_id}`].$el.clientWidth,
          move_train_start: true,
        }
      );
      },
      onintersect(entries, observer, isIntersecting) {
        if (this.$store.state.View.use_intersection_observer === false) {
          this.show_taktarea = true;
        } else {
          if (isIntersecting) {
            this.show_taktarea = true;
          } else {
            this.show_taktarea = false;
          }
        }

      },
    }
  }
</script>
<style>
  .center-activator {
      margin-left: 32px;
  }
  .taktarea-intersection-placeholder {
    height: calc((var(--workpackage_height) + 8px) * var(--taktplan_zoom));

    /* height: 42px; */
    /* width: 100%; */
    /* background-color: green; */
  }
  .tp-taktarea-seperator-container {
    position: absolute;
    width: 100%;
    display: flex;
    justify-content: flex-end;
    bottom: 0;
  }
  .tp-taktarea-seperator-sticky-block {
    position: sticky;
    left: 0;
    width: calc(var(--project_taktplan_spatial_header_width) * 1px * var(--taktplan_zoom) + var(--project_taktplan_ta_header_width) * 1px * var(--taktplan_zoom));
  }
  .tp-taktarea-seperator {
     width: calc(100% - var(--project_taktplan_spatial_header_width) * 1px * var(--taktplan_zoom) - var(--project_taktplan_ta_header_width) * 1px * var(--taktplan_zoom));
  }

  .taktarea-description {
    width: 100px;
  }
</style>
